<div class="fit-content desktop" *ngIf="!helperService.isMobile">
    <!-- Nav Bar -->
    <div class="app-navbar">
        <app-navbar></app-navbar>
    </div>
    <!-- Page Content -->
    <div class="main-content">
	    <app-left-sidebar></app-left-sidebar>
        <div class="content-area">
	        <router-outlet></router-outlet>
        </div>
    </div>
    <!-- Footer -->
    <!-- <div class="footer-flex">
        <app-footer></app-footer>
    </div> -->
</div>

<div class="fit-content mobile" *ngIf="helperService.isMobile">
    <!-- Nav Bar -->
    <div class="app-navbar">
        <app-navbar [isMobile]="helperService.isMobile"></app-navbar>
    </div>
    <!-- Page Content -->
    <div class="main-content">
        <!-- Sidebar overlay backdrop -->
        <div class="sidebar-backdrop" *ngIf="helperService.leftSideMenuOpen" (click)="helperService.leftSideMenuOpen = false"></div>
        <app-left-sidebar *ngIf="helperService.leftSideMenuOpen"></app-left-sidebar>
        <div class="content-area">
	        <router-outlet></router-outlet>
        </div>
    </div>
    <!-- Footer -->
    <!-- <div class="footer-flex">
        <app-footer></app-footer>
    </div> -->
</div>